<template>
  <div class="wrapper">
    <div v-if="type=='3'" class="box">
      <div class="htmlStr" v-html="htmlStr"></div>
    </div>
    <div v-else class="box">
      <img class="imgs" :src="img" alt="" v-for="(img,index) in imgArr" :key="index" @click="showImage(imgArr,index)">
    </div>
  </div>
</template>
<script>
import weChatShareApi from "../../assets/js/weChatShare";
import { handleText } from "../../assets/js/tool";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      goodNbr:'',
      type:'',
      imgArr:[],
      htmlStr:'',
    }
  },
  watch: {},
  computed: {
  },
  methods: {
   showImage(imgArr, index){
     wx.previewImage({
       current:imgArr[index],
       urls:imgArr
     })
    },
    initPage(){
      let that = this
      // let option = {
      //   title: "有米@" + this.userInfo.name + "的店铺",
      //   desc: "欢迎光临我的店铺",
      //   link: location.origin + "/?supNbr=" + this.userInfo.nbr,
      //   images: this.userInfo.imgUrl,
      // };
      // this.weChatShare(option);

      this.$post("/api/customer/queryCommodityDetail", {
        commodityNbr: this.goodNbr,
      })
      .then((res) => {
        if(res.code!=200) return this.$toast({
              message: res.data.message,
              duration: 2000,
            });
        let data = res.object.resp.commodity;
        if (res.code == "200") {
          let resp = res.object.resp;
          if (resp.resp_code == "0" && resp.resp_result == "0") {
            let imgArr=[],htmlStr=''
            if(this.type=='3'){
              data.sourceInfo = handleText(data.sourceInfo);
              htmlStr = data.sourceInfo
            }else if(this.type=='2'){
              imgArr = data.testReport.split(',')
            }else if(this.type=='1'){
              imgArr = data.licensePic.split(',')
            }
            this.htmlStr = htmlStr
            this.imgArr = imgArr

            let userNbr = "";
            if (this.userInfo) {
              userNbr = that.userInfo.nbr;
            }
            let arr=[]
            if (data.commodityLogoList) {
              arr = data.commodityLogoList.split(",");
            }
            let option = {
              title: data.commodityName,
              desc: data.commoditySummary || "",
              link: `${location.origin}/sourceListdetail?nbr=${that.goodNbr}&supNbr=${userNbr}`,
              images: arr[0],
            };
            this.weChatShare(option);
          } else {
            this.$toast({
              message: resp.resp_msg,
              duration: 2000,
            });
          }
        } else {
          this.$toast({
            message: resp.message,
            duration: 2000,
          });
        }
      })
      .catch((err) => {
        this.$toast({
          message: err.message,
          duration: 2000,
        });
      });
    },
  },
  created() {
  },
  mounted() {
    this.goodNbr = this.$route.query.nbr;
    this.type = this.$route.query.type;
    document.title = this.type=='1'?'经营执照':this.type=='2'?'田心检测':'溯源中心';
    this.initPage();
  },
 };
 </script>
<style scoped lang='stylus'>
  .htmlStr >>> img {
    width: 100%;
    height: auto;
  }
</style>
<style scoped lang='less'>
.wrapper{
  width: 100%;
  min-height: 100vh;
  background: #fff;
  box-sizing:border-box;
}
.box{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.imgs{
  width: 7.1rem;
}
.htmlStr {
  width: 7.1rem;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/index/sourceDetail.vue